import React, { useMemo } from 'react';
import { Flex, Form, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { AnyObject } from 'antd/es/_util/type';
import { type TableProps as RcTableProps } from 'rc-table';

interface ITableProps {
	columns: ColumnsType<Record<string, string | number | undefined>>;
	data: AnyObject[];
	totalData: number;
	onPageChange?: (page: number, size: number) => void;
	onPageSizeChange?: (current: number, size: number) => void;
	defaultPageSize?: number;
	pageSizeOptions?: number[];
	operations?: {
		title: string;
		action: (data: AnyObject) => void;
	}[];
	scroll?: RcTableProps['scroll'] & {
        scrollToFirstRowOnChange?: boolean;
    };
}

const TableComponent: React.FC<ITableProps> = ({
	columns,
	data,
	totalData,
	onPageChange,
	onPageSizeChange,
	defaultPageSize = 10,
	pageSizeOptions = [10, 20, 50, 100],
	operations,
	scroll
}) => {
	const combinedColumns = useMemo(() => {
		if (!!operations?.length) {
			return [
				...columns,
				{
					title: 'Operation',
					dataIndex: 'operation',
					width: '20%',
					render: (value: any, record: any, index: any) => {
						return (
							<Flex gap='middle'>
								{(operations || []).map((operation) => (
									<Typography.Link
										onClick={() => operation.action?.(record)}
										key={operation.title}
									>
										{operation.title}
									</Typography.Link>
								))}
							</Flex>
						);
					},
				},
			];
		}
		return columns;
	}, [operations, columns]);

	return (
		<Form>
			<Table
			scroll={scroll}
				bordered
				dataSource={data}
				columns={combinedColumns}
				pagination={{
					showSizeChanger: true,
					total: totalData,
					defaultPageSize,
					pageSizeOptions,
					onChange: (page, pageSize) => {
						onPageChange?.(page, pageSize);
					},
					onShowSizeChange: (current, size) => {
						onPageSizeChange?.(current, size);
					},
				}}
				size='middle'
			/>
		</Form>
	);
};

export default TableComponent;
